<template>
<div class="checkout-page-body">
  <div class="checkout-page-centralizer">
    <h1 class="animation">{{__('Checkout')}}</h1>

    <el-tab
      v-if="showKlarnaPaymentOption"
      v-model="tabIndex"
      >
      <el-tab-item :title="__('Invoice')">
        <invoice-payment />
      </el-tab-item>
      <el-tab-item :title="__('Klarna')">
        <klarna-payment />
      </el-tab-item>
    </el-tab>

    <invoice-payment v-else />
  </div>

  <info-footer />
</div>
</template>
<script>

// import bugsnag from 'services/bugsnag.js'
import KlarnaPayment from 'components/checkoutPage/KlarnaPayment.vue'
import InvoicePayment from 'components/checkoutPage/InvoicePayment.vue'
import InfoFooter from '@/components/landingPage/InfoFooter.vue'
import dataLog from 'services/dataLog.js'

export default {
  name: 'CheckoutPage',
  components: { KlarnaPayment, InvoicePayment, InfoFooter },
  data () {
    return {
      tabIndex: 0
    }
  },
  watch: {
    tabIndex () {
      this.$store.commit('paymentOption', this.tabIndex === 0 ? 'invoice' : 'klarna')
    }
  },
  computed: {
    showKlarnaPaymentOption () {
      return this.$store.getters.showKlarnaPaymentOption
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })

    dataLog.latest({
      status: 'info',
      message: 'Checkout page'
    })
  }
}
</script>
<style lang="less" scoped>
  @import '../style/variables.less';

  .checkout-page-body {
    background-color: #ffffff;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 100%;
    box-sizing: border-box;

    h1 {
      width: 800px;
      max-width: 100%;
    }

    @media (max-width: 800px) {
      justify-content: flex-start;

      h1 {
        width: 400px;
        max-width: 100%;
      }
    }

    @media (max-width: 415px) {
      padding: 0px 15px;
    }
  }

  .checkout-page-centralizer {
    background-color: #ffffff;
    position: relative;
    width: 100%;
    max-width: 700px;

    @media (max-width: 800px) {
      max-width: 400px;
    }
  }
</style>
